import { http } from "./config";
import authHeader from "./auth-header";

export default {
  lista_colaboradores: () => {
    return http.get("/grupos/colaboradores", {
      headers: authHeader(),
    });
  },
  lista_colaboradores_ativos: () => {
    return http.get("/grupos/colaboradores-ativos", {
      headers: authHeader(),
    });
  },
  listar_colaboradores: (params = {}) => {
    return http.get("/grupos/colaboradores/listagem", {
      params,
      headers: authHeader(),
    });
  },
  lista_colaboradores_solides_disponiveis: () => {
    return http.get("/grupos/colaboradores-solides-disponiveis", {
      headers: authHeader(),
    });
  },
  lista_colaboradores_por_departamento: (departamento) => {
    return http.get(`/grupos/colaboradores/departamento/${departamento}`, {
      headers: authHeader(),
    });
  },

  lista_colaboradores_por_empresa: (empresa) => {
    return http.get(`/grupos/colaboradores/empresa`, {
      params: {
        empresa: empresa
      },
      headers: authHeader(),
    });
  },

  salvar_colaborador: (colaborador) => {
    return http.post("/grupos/colaborador", colaborador, {
      headers: authHeader(),
    });
  },

  atualizar_colaborador: (colaborador) => {
    return http.put("/grupos/colaborador/" + colaborador.id, colaborador, {
      headers: authHeader(),
    });
  },

  sincronizar_nascimento_solides: (sobrescrever = true) => {
    return http.post("/grupos/colaboradores/sincronizar-nascimento-solides", null, {
      params: { sobrescrever },
      headers: authHeader(),
    });
  },

  lista_grupos_colaboradorores: (tipo, status) => {
    if (status != null) {
      return http.get("/grupos/grupos", {
        headers: authHeader(),
        params: { tipo, status },
      });
    } else {
      return http.get("/grupos/grupos", {
        headers: authHeader(),
        params: { tipo },
      });
    }
  },

  salvar_grupo_com_colaboradores: (grupoComColaboradores) => {
    return http.post("/grupos/com-colaboradores", grupoComColaboradores, {
      headers: authHeader(),
    });
  },

  atualizar_grupo_colaborador: (grupoColaborador) => {
    return http.put(
      "/grupos/grupo-colaborador/" + grupoColaborador.grupo.id,
      grupoColaborador,
      {
        headers: authHeader(),
      }
    );
  },

  duplicarGrupo: (id) => {
    return http.post("/grupos/duplicar/" + id, null, {
      headers: authHeader(),
    });
  },

  atualizarStatusGrupo: (id, status) => {
    return http.put("/grupos/status/" + id + "/" + status, null, {
      headers: authHeader(),
    });
  },

  // Atualizar compartilhamentos de um grupo
  atualizarCompartilhamentoGrupo: (id, dados) => {
    return http.put(`/grupos/${id}/compartilhamento`, dados, {
      headers: authHeader(),
    });
  },
};
